exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".scenarios{margin:0.5em;width:auto}.padded{padding:1em}.capitalize{text-transform:capitalize}@media (min-width: 960px){.scenarios{margin:20px}}\n", ""]);

